import React from 'react';
import './comingSoon.css';

const ComingSoon = () => (
    <div className="coming-soon">
        <div className="cs-content" style={{ backgroundImage: 'url("/assets/imgs/comingSoon/fondo.png")', }}>
            <img
                className="cs-logo"
                src="https://hisol.com.mx/assets/imgs/header/Logo-Hisol.svg"
                alt="HISOL Enterprises"
            />
            <h1 className="cs-title">COMING SOON!</h1>
        </div>

        <div className="cs-partners">
            <a
                href="https://www.hrd.ltd"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src="/assets/imgs/comingSoon/HRD-Logo.png"
                    alt="HRD Painting & Restoration"
                />
            </a>

            <a
                href="https://www.hisol.com.mx"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src="/assets/imgs/comingSoon/Logotipo-Hisol.png"
                    alt="HISOL Mantenimiento a Gran Altura"
                />
            </a>

            <a
                href="https://www.candc.ltd"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                    src="/assets/imgs/comingSoon/Logo-C&C.png"
                    alt="Concrete & Coatings Ltd"
                />
            </a>
        </div>

        <footer className="cs-footer">
            <p>HISOL ENTERPRISES © 2025. ALL RIGHTS RESERVED</p>
        </footer>
    </div>
);

export default ComingSoon;
